import { render, staticRenderFns } from "./AddSaleCategoryModal.vue?vue&type=template&id=2a6280c9&scoped=true&"
import script from "./AddSaleCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddSaleCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSaleCategoryModal.vue?vue&type=style&index=0&id=2a6280c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6280c9",
  null
  
)

export default component.exports